import gql from 'graphql-tag';

export default gql`
    fragment AuthorisedContacts on Funeral {
        AuthorisedContacts {
            ID
            Name
            Role
            Phones {
                ID
                Number
                Type
                Comment
                Sort
            }
            Email
            AddressLine1
            AddressLine2
            Suburb
            State
            Postcode
            Country
            MailingAddress
        }
    }
`;

export const Prearrangement = gql`
    fragment PrearrangementAuthorisedContacts on Prearrangement {
        AuthorisedContacts {
            ID
            Name
            Role
            Phones {
                ID
                Number
                Type
                Comment
                Sort
            }
            Email
            AddressLine1
            AddressLine2
            Suburb
            State
            Postcode
            Country
        }
    }
`;
